import { render, staticRenderFns } from "./br.vue?vue&type=template&id=2a726c0e&scoped=true&"
import script from "./br.vue?vue&type=script&lang=js&"
export * from "./br.vue?vue&type=script&lang=js&"
import style0 from "./br.vue?vue&type=style&index=0&id=2a726c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a726c0e",
  null
  
)

export default component.exports